import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const MediaContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: ${({ free }) => (free ? '100%' : 'auto')};
  aspect-ratio: ${({ free }) => (free ? 'auto' : '16 / 9')};
  border: 2px solid white;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MediaController = ({ mediaUrls, free = false }) => {
  const [mediaList, setMediaList] = useState(mediaUrls || []); // Ensure mediaUrls is at least an empty array
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [isVideo, setIsVideo] = useState(false);
  const videoRef = useRef(null);

  const goToNextMedia = () => {
    setCurrentMediaIndex((prevIndex) =>
      prevIndex === mediaList.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const currentMedia = mediaList[currentMediaIndex];

    if (!currentMedia || !currentMedia.type) {
      console.error("Invalid media item at index", currentMediaIndex, currentMedia);
      return;
    }

    if (currentMedia.type === 'video') {
      setIsVideo(true);
    } else {
      setIsVideo(false);
      const timer = setTimeout(goToNextMedia, 25000);
      return () => clearTimeout(timer);
    }
  }, [currentMediaIndex, mediaList]);

  const handleVideoEnd = () => {
    if (mediaList.length > 1) {
      goToNextMedia();
    }
  };

  const handleVideoLoaded = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const currentMedia = mediaList[currentMediaIndex];

  return (
    <MediaContainer free={free}>
      {currentMedia ? (
        currentMedia.type === 'video' ? (
          <StyledVideo
            ref={videoRef}
            src={currentMedia.url}
            autoPlay
            muted
            loop
            preload="auto"
            onEnded={handleVideoEnd}
            onLoadedData={handleVideoLoaded}
          />
        ) : (
          <StyledImage src={currentMedia.url} alt="media" />
        )
      ) : (
        <p>Error: No media available to display</p>
      )}
    </MediaContainer>
  );
};

export default MediaController;
